(function () {
  function tryCloseOptin() {
    const closeBtn = document.querySelector('.wa-optin-widget-close-btn, .slw-optin-close');
    const confirmBtn = document.querySelector('#wa-optin-widget-confirm-btn, .slw-optin-confirm');
    if (closeBtn) { closeBtn.click(); return true; }
    if (confirmBtn) { confirmBtn.click(); return true; }
    return false;
  }

  function restoreScroll() {
    document.documentElement.classList.remove('slw-no-scroll');
    document.body.classList.remove('slw-no-scroll');
    document.body.style.overflow = '';
  }

  function closeFastBurst() {
    requestAnimationFrame(() => { tryCloseOptin(); restoreScroll(); });
    setTimeout(() => { tryCloseOptin(); restoreScroll(); }, 60);
    setTimeout(() => { tryCloseOptin(); restoreScroll(); }, 180);
  }

  function observeShort() {
    const obs = new MutationObserver(() => { tryCloseOptin(); restoreScroll(); });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(() => obs.disconnect(), 3000);
  }

  // --- NUEVO: “modo stealth” para esconder por una fracción de segundo
  function stealthOn() {
    document.documentElement.classList.add('hide-wa-optin');
    // quitar stealth tras un momento (suficiente para que el modal no se vea)
    setTimeout(() => document.documentElement.classList.remove('hide-wa-optin'), 800);
  }

  const DRAWERS = ['#halo-cart-sidebar', '.halo-sidebar', '.cart-sidebar', '.drawer', '.cart-drawer'].join(',');
  const CHECKOUT_BTNS = [
    'button[name="checkout"]',
    'a[href*="/checkout"]',
    '.cart__checkout', '.checkout-button', '.btn-checkout', '.button--checkout',
    '[data-checkout]'
  ].join(',');

  document.addEventListener('click', (e) => {
    const inDrawer = e.target.closest(DRAWERS);
    const isCheckout =
      e.target.closest(CHECKOUT_BTNS) ||
      (() => {
        const el = e.target.closest('button, a, [role="button"], .button, .btn');
        return el && /finalizar\s*compra/i.test((el.textContent || '').trim());
      })();

    if (!isCheckout || (!inDrawer && !location.pathname.includes('/cart'))) return;

    // activar stealth para que NO se vea ni un frame
    stealthOn();

    // cerrar popup sin bloquear la navegación
    closeFastBurst();
    setTimeout(closeFastBurst, 120);
    setTimeout(closeFastBurst, 400);
    observeShort();
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreScroll);
  } else {
    restoreScroll();
  }
})();

